export default __webpack_public_path__ + "static/media/warning.ec42f2ae.svg";